export default __webpack_public_path__ + "static/media/step - 15.9063898f.jpeg";